module.exports = __webpack_public_path__ + "img/video_cam-02.9f108e4c.svg";